export default __webpack_public_path__ + "6720d15aed3789bed1e51ea73e3515cd.png";